
import {rollbar}  from './rollbar/rollbar'
import globals from './globals';

export default {
	install: (app: any): void => {
		app.config.errorHandler = (error: any): void => {
			globals.authenticationServiceTracking.trackError(error as Error, null);
			throw error;
		};
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call
		app.provide("rollbar", rollbar);
	},
};
